import { render, staticRenderFns } from "./CustomersActionsColumn.vue?vue&type=template&id=2f36b72c&"
import script from "./CustomersActionsColumn.vue?vue&type=script&lang=js&"
export * from "./CustomersActionsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports